import React from 'react';
type ButtonVariant = 'primary' | 'secondary' | 'ghost';
type ButtonSize = 'sm' | 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
}
const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-white hover:bg-black/90 uppercase tracking-wider font-medium shadow-sm',
  secondary: 'bg-white text-primary border border-primary hover:bg-surface',
  ghost: 'bg-transparent text-text-secondary hover:text-primary hover:bg-surface'
};
const sizeStyles: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-xs rounded-md',
  md: 'px-4 py-2 text-sm rounded-md',
  lg: 'px-6 py-3 text-sm rounded-lg'
};
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  return <button className={`
        inline-flex items-center justify-center
        transition-all duration-150
        focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${className}
      `} disabled={disabled} {...props} data-id="element-1044">
      {children}
    </button>;
}